module.exports = false;


//////////////////
// WEBPACK FOOTER
// /ng-app/node_modules/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = polyfills